<template>
  <BaseChart
    class="box-shadow"
    chart-type="bar"
    ref="base"
    :title="title"
    :subtitle="subtitle"
    :label-y-axis="labelYAxis"
    :data-processor="singleSeriesBarProcessor"
    :category-extractor="labelExtractor"
    :color-map="colorMap"
    :horizontal="horizontal"
  />
</template>

<script setup>
import BaseChart from '@/components/Graph/BaseChart.vue'
import { ref } from 'vue'

const props = defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, required: true },
  labelYAxis: { type: String, required: true },
  colorMap: { type: Object, required: true },
  sortingFn: { type: Function, required: true },
  labelExtractor: { type: Function, required: true },
  valueExtractor: { type: Function, required: true },
  horizontal: { type: Boolean, default: false }
})

const base = ref()

defineExpose({
  setReady: (value) => base.value?.setReady?.(value),
  populateComponent: (...args) => base.value?.populateComponent(...args)
})

const singleSeriesBarProcessor = (data) => {
  const filtered = data.filter(item => props.valueExtractor(item) !== 0)
  const sorted = [...filtered].sort(props.sortingFn)

  const categories = sorted.map(props.labelExtractor)
  const series = [{
    name: Object.keys(props.colorMap)[0] || 'Series',
    data: sorted.map(props.valueExtractor)
  }]

  return { series, categories }
}
</script>